var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hidden",
    clipPath: "url(#clip0_1024_12018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7789 8.86959L11.9436 10.0343C12.0579 9.71052 12.1201 9.36248 12.1201 9.00001C12.1201 7.27982 10.7206 5.88025 9.00036 5.88025C8.6379 5.88025 8.28985 5.94248 7.96606 6.05673L9.13079 7.22146C10.0104 7.28544 10.7149 7.98998 10.7789 8.86959Z",
    fill: "url(#paint0_linear_1024_12018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.17727 13.5805C5.67492 14.4144 7.32129 14.8542 8.9427 14.8542H9.00035C10.1334 14.8619 11.2785 14.6534 12.3775 14.2467L13.8136 15.6828C13.944 15.8132 14.1149 15.8786 14.2861 15.8786C14.4573 15.8786 14.6282 15.8132 14.7586 15.6828C15.0195 15.4219 15.0195 14.999 14.7586 14.7382L3.25441 3.23397C2.99355 2.97312 2.57062 2.97312 2.30977 3.23397C2.04891 3.49483 2.04891 3.91776 2.30977 4.17862L3.18023 5.04909C2.0707 5.83694 1.09055 6.84171 0.306914 8.00187C-0.102305 8.60831 -0.102305 9.39194 0.306914 9.99874C1.31766 11.4953 2.65605 12.7339 4.17691 13.5808L4.17727 13.5805ZM8.91281 10.7813C7.99875 10.7367 7.26363 10.0016 7.21898 9.08749L8.91281 10.7813ZM1.41434 8.74894C2.15191 7.65663 3.08461 6.72147 4.14035 6.00886L6.06762 7.93612C5.94668 8.26835 5.88094 8.62624 5.88094 8.9996C5.88094 10.7198 7.28051 12.1194 9.0007 12.1194C9.37406 12.1194 9.73195 12.0533 10.0642 11.9323L11.321 13.1892C10.5746 13.4061 9.81281 13.5179 9.05871 13.5179C9.04113 13.5179 9.0232 13.5179 9.00562 13.5179H8.99648C7.58355 13.5274 6.14356 13.1456 4.82766 12.4133C3.48891 11.668 2.30871 10.5742 1.41504 9.25097C1.31203 9.09839 1.31203 8.90151 1.41504 8.74929L1.41434 8.74894Z",
    fill: "url(#paint1_linear_1024_12018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.6938 8.00153C16.6831 6.50493 15.3447 5.26638 13.8238 4.41946C12.3262 3.58556 10.6798 3.14575 9.05804 3.14575C9.0387 3.14575 9.01972 3.14575 9.00038 3.14575C8.98105 3.14575 8.96206 3.14575 8.94272 3.14575C7.83917 3.14575 6.72401 3.34966 5.6521 3.7427L6.71065 4.80126C7.44718 4.59032 8.19882 4.48169 8.94272 4.48169H8.99581H9.00495C10.4161 4.47114 11.8579 4.85399 13.1738 5.5863C14.5125 6.33161 15.6927 7.42532 16.5864 8.7486C16.6894 8.90118 16.6894 9.09806 16.5864 9.25028C15.8541 10.3345 14.9298 11.264 13.8839 11.9745L14.8433 12.934C15.9434 12.1486 16.9155 11.1498 17.6935 9.9977C18.1027 9.39126 18.1027 8.60763 17.6935 8.00118L17.6938 8.00153Z",
    fill: "url(#paint2_linear_1024_12018)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1024_12018",
    x1: 7.96606,
    y1: 7.95728,
    x2: 12.1201,
    y2: 7.95728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04AEED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1024_12018",
    x1: 5.57089e-8,
    y1: 9.45847,
    x2: 14.9542,
    y2: 9.45847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04AEED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1024_12018",
    x1: 5.6521,
    y1: 8.03985,
    x2: 18.0004,
    y2: 8.03985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04AEED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_12018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvisible);
export default __webpack_public_path__ + "static/media/icon_invisible.a92764c12b3869df0d2e7f50cd361869.svg";
export { ForwardRef as ReactComponent };